import React, { useEffect, useState } from 'react';
import { Breadcrumbs } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import RequestStartUpForm from './RequestStartUpForm';
import { updateRequestStartUp, viewRequestStartUp } from '../../Services/Utils/RequestStartupApis';
import { getImage } from '../../Services/Utils/FileApis';
import { notifySet } from '../../Services/Actions/CommonActions';

function UpdateStartUpRequest() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  useEffect(() => {
    viewStartUpRequest();
  }, []);
  const [editData, setEditData] = useState();
  const viewStartUpRequest = () => {
    const data = { id: params?.id };
    viewRequestStartUp(data).then((res) => {
      const { hasError, view } = res;
      setEditData(view);
      if (hasError === false) {
        dispatch(change('requestStartUpForm', 'servicePartnerName', view.serviceProviderName));
        dispatch(change('requestStartUpForm', 'websiteURL', view.websites));
        dispatch(change('requestStartUpForm', 'contactDetails', view.contactDetails));
        dispatch(change('requestStartUpForm', 'remark', view.remarks));
        const category = {
          id: view.categoryView.id,
          text: view.categoryView.name,
          path: `${getImage(view.categoryView.bannerFileView)}`,
        };
        dispatch(change('requestStartUpForm', 'serviceCategory', category));
        const status = { id: view.status.key, label: view.status.value };
        dispatch(change('requestStartUpForm', 'status', status));
      }
    });
  };
  const onSubmit = (formData) => {
    const data = {
      id: params?.id,
      categoryView: {
        id: formData.serviceCategory.id,
      },
      serviceProviderName: formData.servicePartnerName,
      websites: formData.websiteURL,
      contactDetails: formData.contactDetails,
      remarks: formData.remark,
      status: { key: formData.status.id },
    };
    updateRequestStartUp(data).then((res) => {
      const { hasError, message } = res;
      if (hasError === false) {
        navigate('/support-list');
        dispatch(notifySet({ type: 'success', message }));
      } else if (hasError === true) {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };
  return (
    <div>
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/support-list">Support</Link>
          <Link to="#">Update Support Request</Link>
        </Breadcrumbs>
      </div>
      <RequestStartUpForm
        onSubmit={onSubmit}
        action="edit"
        SubmitText="Update"
        mainText="Update Support Request"
        editData={editData}
      />
    </div>
  );
}

export default UpdateStartUpRequest;
